import React, { useEffect, useState } from "react";
import {
  Container,
  RightContainer,
  Title,
  DescriptionText,
} from "./styled";
import DescriptionIcon from "@mui/icons-material/TextSnippetOutlined";
import BottomButtonGroup from "../../../Pages/BoardPage/BoardComponents/BottomButtonGroup/BottomButtonGroup.js";
import { useDispatch, useSelector } from "react-redux";
import { descriptionUpdate } from "../../../../Services/cardService";
import RichTextEditor from "../../../RichTextEditor.js";
import parse from 'html-react-parser'

const Description = () => {
  const thisCard = useSelector((state) => state.card);
  const dispatch = useDispatch();
  const [inputFocus, setInputFocus] = useState(false);
  const [description, setDescription] = useState(thisCard.description);

  const handleSaveClick = async () => {
    setInputFocus(false);
    await descriptionUpdate(
      thisCard.cardId,
      thisCard.listId,
      thisCard.boardId,
      description,
      dispatch
    );
  };

  useEffect(() => {
    setDescription(thisCard.description);
  }, [thisCard.description]);

  return (
    <Container>
      <DescriptionIcon fontSize="small" />
      <RightContainer>
        <Title>Description</Title>
        {!inputFocus ? (
          <DescriptionText onClick={() => setInputFocus(true)}>
            {description.length > 0 ? parse(description) : "Add a more detailed description..."}
          </DescriptionText>
        ) : (
          <RichTextEditor
            placeholder={"Add a more detailed description..."}
            content={description}
            setContent={setDescription}
            setFocus={setInputFocus}
          />
        )}
        <div style={{ display: inputFocus ? "block" : "none" }}>
          <BottomButtonGroup
            closeCallback={() => {
              setInputFocus(false);
              setDescription(thisCard.description);
            }}
            clickCallback={handleSaveClick}
            title="Save"
          />
        </div>
      </RightContainer>
    </Container>
  );
};

export default Description;
